<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    :modelNameSingular="modelNameSingular"
    :formErrors="formErrors"
    ref="baseDelete"
  >
    <p> Você tem certeza que deseja deletar a categoria de patrimônio <b>{{this.entry.name}}</b>?</p>
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "@shared_components/base_delete.vue";

export default {
 data () {
  return {
    error: null,
    loading: true,
    formErrors: []
  }
},
components: {
  BaseDelete: BaseDelete
},
props: {
  entry: Object,
  modelNameSingular: String,
},
 methods: {
   destroyServerEntry: function(patrimonyCategory) {
     this.loading = true;
      this.$apollo
        .mutate({
          mutation: DESTROY_PATRIMONY_CATEGORY_MUTATION,
          variables: {
            id: patrimonyCategory.id,
          }
        })
        .then(response => {
          var errors = response.data.destroyPatrimonyCategory.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$emit("entry-destroyed");
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
   },
   destroyEntry: function() {
     this.destroyServerEntry(this.entry);
   },
 }
}
const DESTROY_PATRIMONY_CATEGORY_MUTATION = gql `
  mutation($id: ID!) {
    destroyPatrimonyCategory(id: $id) {
      patrimonyCategory {
        id
        name
        kind
      }
      errors
    }
  }
`;
</script>

<style scoped></style>